exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ZoomText{display:flex}.ZoomText .label{font-size:var(--font-size-default)}.ZoomText .value{color:var(--gray-7)}", ""]);

// exports
